import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

// --- DONNÉES ENRICHIES & COMPLÈTES ---
const careerDomains = [
  { value: 'ingenierie', label: 'Ingénierie & BTP' },
  { value: 'digital', label: 'Informatique & Digital' },
  { value: 'sante', label: 'Santé & Médecine' },
  { value: 'business', label: 'Commerce, Gestion & Finance' },
  { value: 'juridique', label: 'Droit & Sciences Politiques' },
  { value: 'architecture', label: 'Architecture & Design' },
  { value: 'industrie', label: 'Industrie & Aéronautique' }
];

const careersByDomain = {
  ingenierie: [
    { value: 'ing-civil', label: 'Ingénieur Génie Civil', tracks: ['Sciences Math A/B', 'STM'], salary: '9k - 18k MAD', searchKeyword: 'Génie Civil' },
    { value: 'ing-indus', label: 'Ingénieur Industriel', tracks: ['Sciences Math', 'STE'], salary: '10k - 20k MAD', searchKeyword: 'Industriel' },
    { value: 'ing-topographe', label: 'Ingénieur Topographe', tracks: ['Sciences Math'], salary: '9k - 17k MAD', searchKeyword: 'Hassania' },
    { value: 'ing-elec', label: 'Ingénieur Électrique', tracks: ['STE', 'Sciences Math'], salary: '8k - 16k MAD', searchKeyword: 'Électrique' }
  ],
  digital: [
    { value: 'data-scientist', label: 'Data Scientist / IA', tracks: ['Sciences Math'], salary: '12k - 25k MAD', searchKeyword: 'Informatique' },
    { value: 'dev-fullstack', label: 'Développeur Fullstack', tracks: ['Sciences Math', 'PC', 'Technique'], salary: '10k - 22k MAD', searchKeyword: 'Informatique' },
    { value: 'cybersecurite', label: 'Expert Cybersécurité', tracks: ['Sciences Math'], salary: '11k - 24k MAD', searchKeyword: 'ENSIAS' },
    { value: 'ux-designer', label: 'UX/UI Designer', tracks: ['Arts', 'PC'], salary: '8k - 16k MAD', searchKeyword: 'Multimédia' }
  ],
  sante: [
    { value: 'medecin', label: 'Médecin Généraliste', tracks: ['PC', 'SVT', 'Sc. Math'], salary: '12k - 30k MAD', searchKeyword: 'Médecine' },
    { value: 'dentiste', label: 'Médecin Dentiste', tracks: ['PC', 'SVT'], salary: '12k - 25k MAD', searchKeyword: 'Dentaire' },
    { value: 'pharmacien', label: 'Pharmacien', tracks: ['PC', 'SVT'], salary: '10k - 25k MAD', searchKeyword: 'Pharmacie' },
    { value: 'kine', label: 'Kinésithérapeute', tracks: ['SVT', 'PC'], salary: '6k - 15k MAD', searchKeyword: 'Santé' }
  ],
  business: [
    { value: 'expert-comptable', label: 'Expert-Comptable', tracks: ['Éco-Gestion', 'Sc. Math'], salary: '10k - 25k MAD', searchKeyword: 'ENCG' },
    { value: 'trader', label: 'Trader / Finance de marché', tracks: ['Sc. Math', 'Éco'], salary: '15k - 40k MAD', searchKeyword: 'Finance' },
    { value: 'marketing', label: 'Directeur Marketing', tracks: ['Éco-Gestion'], salary: '10k - 20k MAD', searchKeyword: 'Commerce' },
    { value: 'auditeur', label: 'Auditeur Financier', tracks: ['Éco-Gestion'], salary: '9k - 18k MAD', searchKeyword: 'ISCAE' },
    { value: 'rh', label: 'Responsable RH', tracks: ['Éco-Gestion', 'Lettres'], salary: '8k - 15k MAD', searchKeyword: 'ENCG' }
  ],
  juridique: [
    { value: 'avocat', label: 'Avocat d\'Affaires', tracks: ['Lettres', 'Éco'], salary: '10k - 40k MAD', searchKeyword: 'Droit' },
    { value: 'notaire', label: 'Notaire', tracks: ['Lettres', 'Éco'], salary: '15k - 30k MAD', searchKeyword: 'Droit' },
    { value: 'magistrat', label: 'Magistrat / Juge', tracks: ['Lettres'], salary: '12k - 22k MAD', searchKeyword: 'Droit' }
  ],
  architecture: [
    { value: 'architecte', label: 'Architecte', tracks: ['Sc. Math', 'Technique'], salary: '10k - 30k MAD', searchKeyword: 'Architecture' },
    { value: 'urbaniste', label: 'Urbaniste', tracks: ['Sc. Math', 'Technique'], salary: '9k - 18k MAD', searchKeyword: 'INAU' },
    { value: 'designer-int', label: 'Architecte d\'intérieur', tracks: ['Arts', 'Technique'], salary: '7k - 15k MAD', searchKeyword: 'Beaux-Arts' }
  ],
  industrie: [
    { value: 'ing-aero', label: 'Ingénieur Aéronautique', tracks: ['Sc. Math', 'STM'], salary: '11k - 22k MAD', searchKeyword: 'Aéronautique' },
    { value: 'logistique', label: 'Responsable Logistique', tracks: ['Éco', 'Technique'], salary: '8k - 16k MAD', searchKeyword: 'Logistique' },
    { value: 'automatisme', label: 'Ingénieur Automatisme', tracks: ['STE', 'Sc. Math'], salary: '9k - 18k MAD', searchKeyword: 'ENSA' }
  ]
};

const CareerExplorer = () => {
  const [selectedDomain, setSelectedDomain] = useState('');
  const [selectedCareer, setSelectedCareer] = useState('');
  const navigate = useNavigate();

  const availableCareers = selectedDomain ? careersByDomain[selectedDomain] : [];
  const selectedCareerData = availableCareers?.find(c => c.value === selectedCareer);

  // Correction navigation : On envoie le mot-clé exact dans l'URL
  const handleExploreSchools = () => {
    if (selectedCareerData?.searchKeyword) {
      navigate(`/post-bac-database?search=${encodeURIComponent(selectedCareerData.searchKeyword)}`);
    } else {
      navigate('/post-bac-database');
    }
  };

  return (
    <div className="bg-card border border-border rounded-xl p-6 shadow-sm animate-fade-in font-sans">
      {/* Header */}
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center text-primary">
          <Icon name="Compass" size={20} />
        </div>
        <div>
          <h3 className="text-lg font-bold text-foreground">Explorateur de Carrières</h3>
          <p className="text-xs text-muted-foreground">Trouvez la filière bac idéale pour votre métier de rêve.</p>
        </div>
      </div>

      <div className="space-y-5">
        {/* 1. Select Domain */}
        <div>
          <label className="text-sm font-semibold text-foreground mb-2 block">Domaine d'activité</label>
          <div className="relative">
            <select
              className="w-full p-3 bg-background border border-border rounded-lg appearance-none focus:ring-2 focus:ring-primary/20 outline-none transition-all text-sm font-medium text-foreground cursor-pointer hover:bg-muted/50"
              value={selectedDomain}
              onChange={(e) => {
                setSelectedDomain(e.target.value);
                setSelectedCareer('');
              }}
            >
              <option value="">Sélectionner un domaine...</option>
              {careerDomains.map((domain) => (
                <option key={domain.value} value={domain.value}>{domain.label}</option>
              ))}
            </select>
            <div className="absolute right-3 top-3.5 pointer-events-none text-muted-foreground">
              <Icon name="ChevronDown" size={16} />
            </div>
          </div>
        </div>

        {/* 2. Select Career (Only if domain selected) */}
        {selectedDomain && (
          <div className="animate-fade-in-up">
            <label className="text-sm font-semibold text-foreground mb-2 block">Métier visé</label>
            <div className="relative">
              <select
                className="w-full p-3 bg-background border border-border rounded-lg appearance-none focus:ring-2 focus:ring-primary/20 outline-none transition-all text-sm font-medium text-foreground cursor-pointer hover:bg-muted/50"
                value={selectedCareer}
                onChange={(e) => setSelectedCareer(e.target.value)}
              >
                <option value="">Choisir un métier spécifique...</option>
                {availableCareers.map((career) => (
                  <option key={career.value} value={career.value}>{career.label}</option>
                ))}
              </select>
              <div className="absolute right-3 top-3.5 pointer-events-none text-muted-foreground">
                <Icon name="ChevronDown" size={16} />
              </div>
            </div>
          </div>
        )}

        {/* 3. Results Card */}
        {selectedCareerData && (
          <div className="mt-6 p-5 bg-muted/30 rounded-xl border border-border animate-fade-in-up">
            <h4 className="font-bold text-foreground flex items-center mb-4 text-lg">
              <Icon name="Target" size={20} className="mr-2 text-primary" />
              {selectedCareerData.label}
            </h4>
            
            <div className="space-y-4">
              <div className="flex justify-between items-center text-sm border-b border-border/50 pb-3">
                <span className="text-muted-foreground font-medium">Salaire débutant (Maroc)</span>
                <span className="font-bold text-foreground bg-green-50 text-green-700 px-2 py-1 rounded">
                    {selectedCareerData.salary}
                </span>
              </div>
              
              <div>
                <span className="text-xs font-bold text-muted-foreground uppercase tracking-wide block mb-2">
                  Bacs Recommandés :
                </span>
                <div className="flex flex-wrap gap-2">
                  {selectedCareerData.tracks.map((track, idx) => (
                    <span key={idx} className="px-3 py-1 bg-background border border-border rounded-md text-xs font-semibold text-primary shadow-sm">
                      {track}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <div className="mt-5 pt-2">
                <Button 
                    variant="default" 
                    size="sm" 
                    className="w-full justify-center shadow-md hover:shadow-lg transition-shadow"
                    onClick={handleExploreSchools}
                    iconName="Search"
                >
                    Voir les écoles pour ce métier
                </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CareerExplorer;